import config from '../../config';

export function loginToFb() {
  return new Promise((res) => {
    window.passFBAuthCode = (code, _window) => {
      _window.close();
      res(code);
    };
    const url = `https://www.facebook.com/v2.8/dialog/oauth?client_id=${config.fbId}&display=popup&response_type=code&redirect_uri=${window.location.origin}`;
    window.open(url, '_blank');
  });
}



/** WEBPACK FOOTER **
 ** ./src/logic/auth/fb.js
 **/